// extracted by mini-css-extract-plugin
export default {"title":"TitileBack_title__IgCEB"};